import { SetMetadata } from '@nestjs/common';

export const REQUIRE_SUBMODULO_KEY = 'require_submodulo';

/**
 * Decorator que marca un endpoint como requeridor de un submódulo activo.
 * Cubre tanto submódulos incluidos en el módulo raíz como addons contratados
 * en `suscripcion_submodulos`.
 *
 * @example
 * @RequireSubmodulo('VEN_POS')
 * @Get()
 * findAll() { ... }
 */
export const RequireSubmodulo = (codigo: string) =>
  SetMetadata(REQUIRE_SUBMODULO_KEY, codigo);
